import BaseLayer from "./BaseLayer";
import {hsvToRgb} from "../../../utils/utils";
import {drawLine, drawRectangle, getInvertedColor, getNorthBounds, getWestBounds} from "../utils/map_utils";

class StitchGraphTextv2 extends BaseLayer {

    id = "stitchGraphTextv2";
    label = "Text-Labels";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchStartPosR0, stitchDoubtMap, textColor, textSize} = this.props;
        let {y_fields, tile_width, tile_height, uperpixel, img_type} = this.props.slide;
        if (stitchStartPosR0 && (stitchStartPosR0.length === 0 || Object.keys(stitchStartPosR0).length === 0)) {
            return;
        }
        if (stitchDoubtMap && (stitchDoubtMap.length === 0 || Object.keys(stitchDoubtMap).length === 0)) {
            return;
        }

        const tile_width_microns = tile_width * uperpixel;
        const tile_height_microns = tile_height * uperpixel;

        const stitchDoubtMapList = Object.keys(stitchDoubtMap).map(function (key) {
            return stitchDoubtMap[key];
        });
        const topDoubtVals = stitchDoubtMapList.map(function (tileDoubt) {
            return tileDoubt["top"];
        });
        const leftDoubtVals = stitchDoubtMapList.map(function (tileDoubt) {
            return tileDoubt["left"];
        });
        const allDoubtVals = topDoubtVals.concat(leftDoubtVals);
        let maxDoubtLevel = Math.max(...allDoubtVals);
        let minDoubtLevel = Math.min(...allDoubtVals);

        const margin = 3 / 10;
        const sizeOfMarker = 0.2;
        const stroke = 1;
        let color = `rgba(200, 200, 200, 0.1)`;
        let txtColor = `rgba(10, 10, 10, 0.5)`;
        for (const [tileKey, doubt] of Object.entries(stitchDoubtMap)) {
            const xHori = parseInt(tileKey.split('y')[0].split('x')[1]);
            let yVerti = parseInt(tileKey.split('y')[1].split('.' + img_type)[0]);
            yVerti = y_fields - yVerti - 1;

            color = getInvertedColor(maxDoubtLevel, minDoubtLevel, doubt["top"]);
            // NORTH MARKERS
            const northBounds = getNorthBounds(xHori, yVerti, sizeOfMarker, margin,
                tile_width_microns, tile_height_microns);
            drawRectangle(northBounds, this.layer.getSource(), true, stroke, color);
            drawLine((xHori + 0.5) * tile_width_microns, (yVerti + 1) * tile_height_microns, 1,
                this.layer.getSource(), "lvl=" + doubt["top"], 1, txtColor, "", textColor, textSize);

            color = getInvertedColor(maxDoubtLevel, minDoubtLevel, doubt["left"]);
            // WEST MARKERS
            const westBounds = getWestBounds(xHori, yVerti, sizeOfMarker, margin,
                tile_width_microns, tile_height_microns);
            drawRectangle(westBounds, this.layer.getSource(), true, stroke, color);
            drawLine(xHori * tile_width_microns, (yVerti + 0.5) * tile_height_microns, 1,
                this.layer.getSource(), "lvl=" + doubt["left"], 0.25, txtColor, "", textColor, textSize);
        }

        const tileCounts1 = stitchStartPosR0.map(function (ccMeta) {
            return ccMeta["tileCount"];
        })
            .filter(function (tileCount) {
                return tileCount > 1;
            });
        let maxTileCount = Math.max(...tileCounts1);
        let minTileCount = Math.min(...tileCounts1);
        // draw squares at all `stitchStartPosR0`
        for (const ccMeta of stitchStartPosR0) {
            const position = ccMeta["ccStartPos"];
            const tileCount = ccMeta["tileCount"];
            const colorScore = 180 - Math.floor(180 * ((maxTileCount - tileCount) / (maxTileCount - minTileCount)));
            const {r, g, b} = hsvToRgb(colorScore / 360, 1, 1);
            const txtColor = `rgb(${r},${g},${b})`;

            const xHori = position["col"];
            let yVerti = position["row"];
            yVerti = y_fields - yVerti - 1;

            if (tileCount > 1) {
                drawLine((xHori + 0.5) * tile_width_microns, (yVerti + 0.5) * tile_height_microns, 1,
                    this.layer.getSource(), "tile=" + tileCount.toString(), 1, txtColor, "",
                    textColor, textSize);
            }
        }
        resolve();
    });
}

export default StitchGraphTextv2;
